

import axios from 'axios';
import { baseUrl_SPB} from '../BaseUrl';
import { screen } from '@testing-library/react';
   
 async function switchUserRole(token,userEmail,changeToRole) {
       
        let tokenv=token;
           
           try {
               const response = await fetch(`${baseUrl_SPB}/api/v1/user/switchuserrole?email=${userEmail}&role=${changeToRole}`, {
                   method: 'GET',
   
                   headers: {
                       'Content-Type': 'application/json',
                       'Authorization': 'Bearer ' + tokenv
                   },
                   
               });
   
               const jsonResponse = await response.json();
            return jsonResponse;
   
           } catch (error) {
               console.error('Error:', error);
           }
       }


async function meDetails(token,setRole,setAdditionalUserInfo) {
    let tokenv=token;
    axios.get(`${baseUrl_SPB}/api/v1/user/me`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + tokenv,
          
        }
      })
        .then(userDetailsResponse => {
          let response = userDetailsResponse.data;
          setRole(response.role);
          console.log("HERE CHANGED CODE");
          setAdditionalUserInfo(response);
          return response.role;
        })
        .catch(error => {
          console.error('Error fetching user details and role:', error);
       
        });
}
      
   export  {switchUserRole,meDetails};
   
   
   

